import React from 'react';

import Layout from '@common/Layout';

import Header from '@sections/Header';
import Products from '@sections/Products';
import Discover from '@sections/Discover';
import Footer from '@sections/Footer';

export default ({ location }) => (
  <Layout location={location}>
    <Header />
    <Products />
    <Discover />
    <Footer />
  </Layout>
);
